import { render } from "./PCChargeAlertModal.vue?vue&type=template&id=ffc50dae&scoped=true"
import script from "./PCChargeAlertModal.vue?vue&type=script&lang=js"
export * from "./PCChargeAlertModal.vue?vue&type=script&lang=js"

import "./PCChargeAlertModal.vue?vue&type=style&index=0&id=ffc50dae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc50dae"]])

export default __exports__